module.exports = "/packs/media/images/strategy-investment-cc67694cc3c82e31e070a11a32a014ba.png";